module.exports = __webpack_public_path__ + "img/flower-daffodil.72d315cf.svg";